import Flickity from './flickity';
import imagesLoaded from 'imagesloaded';

export default class Carousel {

	constructor(element) {
		this.handleReady = this.handleReady.bind(this);
		this.handleWindowResize = this.handleWindowResize.bind(this);
		this.element = element;
	}

	init() {
		if (this.element instanceof HTMLElement) {
			window.addEventListener('resize', this.handleWindowResize);
			imagesLoaded(this.element, { background: true }, () => {
				new Flickity(this.element, {
					contain: true,
					cellAlign: 'left',
					groupCells: true,
					pageDots: true,
					wrapAround: false,
					on: {
						ready: this.handleReady,
					}
				});
			});
		}
	}

	handleReady() {
		this.setDotsNavHeight();
	}

	handleWindowResize() {
		this.setDotsNavHeight();
	}

	setDotsNavHeight() {
		const dotsNav = this.element.querySelector('.flickity-page-dots');
		if (dotsNav instanceof HTMLElement) {
			const dotsNavHeight = dotsNav.clientHeight;
			const navButtons = this.element.querySelectorAll('.flickity-button');
			if (navButtons instanceof NodeList) {
				navButtons.forEach(navButton => {
					if (navButton instanceof HTMLElement) {
						const navButtonHeight = navButton.clientHeight;
						navButton.style.bottom = `${(((navButtonHeight / 2) - (dotsNavHeight / 2)) * -1)}px`;
					}
				});
			}
		}
	}
}
